import BaseTableController from './base_table_controller';

// dp_id 415 — data_grid: { rows: [{ site_id, site_name, biodiversity_area, area }] }
// siteOptions value: [{ id, name }] — sourced from dp_id 2300 rows
export default class extends BaseTableController {
  static values = { siteOptions: Array, biodiversityOptions: Array };

  searchableFields = ['site_name', 'biodiversity_area'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => {
            let site_id = r.site_id ?? null;
            // Backfill site_id from siteOptions for rows saved before the id column existed
            if (site_id === null && r.site_name) {
              const site = this.siteOptionsValue.find((s) => s.name === r.site_name);
              if (site) site_id = site.id;
            }
            return {
              site_id,
              site_name: r.site_name ?? '',
              biodiversity_area: r.biodiversity_area ?? '',
              area: r.area ?? null,
            };
          })
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { site_id: null, site_name: '', biodiversity_area: '', area: null };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    const field = el.dataset.field;

    if (field === 'site_name') {
      const selectedName = el.value;
      const site = this.siteOptionsValue.find((s) => s.name === selectedName);
      this.rows[index].site_name = selectedName;
      this.rows[index].site_id = site ? site.id : null;
      // Re-render all rows so other dropdowns exclude the newly selected site
      this.renderRows();
    } else {
      this.rows[index][field] =
        el.type === 'number' ? (el.value === '' ? null : parseInt(el.value, 10)) : el.value;
    }

    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    const idTd = document.createElement('td');
    idTd.textContent = row.site_id ?? '';
    idTd.className = 'text-center';
    tr.appendChild(idTd);

    const usedNames = new Set(
      this.rows.filter((r, i) => i !== index && r.site_name).map((r) => r.site_name)
    );
    const availableOptions = this.siteOptionsValue
      .filter((s) => !usedNames.has(s.name))
      .map((s) => s.name);
    tr.appendChild(this.buildSelectCell(row, index, 'site_name', availableOptions));
    tr.appendChild(
      this.buildSelectCell(row, index, 'biodiversity_area', this.biodiversityOptionsValue)
    );

    const areaTd = document.createElement('td');
    const areaInput = document.createElement('input');
    areaInput.type = 'number';
    areaInput.min = '0';
    areaInput.step = '1';
    areaInput.placeholder = '0';
    areaInput.className = 'form-control w-100';
    areaInput.dataset.rowIndex = index;
    areaInput.dataset.field = 'area';
    areaInput.dataset.action = `input->${this.identifier}#updateField`;
    if (row.area !== null && row.area !== undefined) areaInput.value = row.area;
    areaTd.appendChild(areaInput);
    tr.appendChild(areaTd);

    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }
}
